import layoutMap from '../layoutMap';
import questionTypes from '../questionTypes';
import createEmptyOptionCollection from '../../utils/createEmptyOptionCollection';
import personalLabelMap from '../personalLabelMap';
import getCommonBlockProps from './getCommonBlockProps';
import { DEFAULT_MAX_OPTIONS_COUNT, DEFAULT_ROW_LABEL } from './constants';
import { STYLING_KEY_QUESTION_TEXT } from '../../constants/stylingKey';

export default {
  type: questionTypes.respondentInfoMulti,
  getDefaultProps: () => ({
    ...getCommonBlockProps(),
    personalLabelType: personalLabelMap.noLabel,
    layout: layoutMap.horizontal,
    options: createEmptyOptionCollection(1, DEFAULT_ROW_LABEL),
  }),
  limits: {
    options: {
      max: DEFAULT_MAX_OPTIONS_COUNT,
      min: 1,
    },
  },
  settings: {
    defaultStylingEntity: STYLING_KEY_QUESTION_TEXT,
    isRequiredField: () => false,
    isUniqueField: () => false,
    isTextRequired: () => true,
  },
};
